export default "__VITE_ASSET__DO5Vy9lr__"